<template>
    <div>
        <div id="main_wrap" class="login_wrap">
            <div class="login_bg_slider_wrap">
                <div class="main_banner_slider" v-if="banner">
                    <div class="main_banner_slider_inner" :style="{'background-image': 'url('+banner?.background_file+')'}">
                        
                    </div>
                </div>
            </div>
            <div class="top_logo">
                <a :href="siteUrl" target="_blank"><img src="assets/media/images/logo.png" alt=""></a>
            </div>
            <div class="signup_content_wrap">
                <div class="signup_inner_content">
                    <section class="login_container">
                        <section class="wrapper">
                            <header>
                                <div class="logo">
                                    <span>
                                        <a :href="siteUrl" target="_blank">
                                            <img src="assets/media/images/logo.png" alt="">
                                        </a>
                                    </span>
                                </div>
                                <h1>Welcome back!</h1>
                                <p>Login to your cloud console</p>
                            </header>
                            <section class="main-content">
                                <form @submit.prevent="login">
                                    <div class="mb-3">
                                        <input type="email" class="form-control" placeholder="Email" v-model="form.email">
                                        <v-errors :errors="errorFor('email')"></v-errors>
                                        <p v-if="isShowResend"><a class="resend_link" type="button" @click.prevent="resendVerification">Resend verification link</a></p>
                                    </div>
                                    <div class="mb-3">
                                        <input type="password" class="form-control" placeholder="Password" v-model="form.password">
                                        <v-errors :errors="errorFor('password')"></v-errors>
                                    </div>
                                    <button @click.prevent="login">Login</button>
                                </form>
                            </section>
                            <footer>
                                <p><router-link :to="{name : 'forgot-password'}"  title="Forgot Password">Forgotten Password?</router-link></p>
                                <p><router-link :to="{name : 'register'}" title="Register">Register</router-link></p>
                            </footer>
                        </section>
                    </section>
                </div>
            </div>
        </div>
        <div class="chatbot_wrap">
            <div class="chatbot_icon" @click="openChatBox">
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
                    <rect width="36.7813" height="30.888" rx="7" fill="#F3F3F3"/>
                    <path d="M6.13281 30.2148H17.627L8.66437 37.9172C8.35971 38.179 7.9713 38.323 7.56958 38.323V38.323V38.323C6.76096 38.2686 6.13281 37.5969 6.13281 36.7864V30.2148Z" fill="#F3F3F3"/>
                    <ellipse cx="9.05254" cy="16.1069" rx="3.20879" ry="3.04054" fill="#B0B0B0"/>
                    <ellipse cx="18.1463" cy="16.2046" rx="3.20879" ry="3.04054" fill="#B0B0B0"/>
                    <ellipse cx="27.2478" cy="16.1069" rx="3.20879" ry="3.04054" fill="#B0B0B0"/>
                    <path d="M42.1875 43.1406H33.5938L40.3 49.106C40.524 49.3053 40.8134 49.4154 41.1133 49.4154V49.4154V49.4154C41.7182 49.3733 42.1875 48.8703 42.1875 48.2639V43.1406Z" fill="#B0B0B0"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.1875 33.7299V36.142C17.1875 40.008 20.3215 43.142 24.1875 43.142H41.4373C45.3032 43.142 48.4373 40.008 48.4373 36.142V25.043C48.4373 21.177 45.3032 18.043 41.4373 18.043H39.062V26.7299C39.062 30.5958 35.928 33.7299 32.062 33.7299H17.1875Z" fill="#B0B0B0"/>
                </svg>
            </div>
            <div class="chatbot_box_wrap chatbot_box_wrap_no_login" :class="{open: isOpenChat}">
                <div class="without_login_popup">
                    <h4>Want To Start Chat</h4>
                    <div class="d_flex_center">
                        <router-link :to="{name : 'login'}" class="btn btn-sm btn-primary">Please Login</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import validationErrors from "@/mixins/validationErrors";
export default {
    mixins: [validationErrors],
    computed: {
        ...mapGetters({
            appName: 'getAppName'
        })
    },
    components: {},
    data() {
        return {
            siteUrl: process.env.VUE_APP_SITE_URL,
            form: {
                email: '',
                password: '',
                device: 'web',
            },
            isShowResend: false,
            banner: null,
            isOpenChat: false,
        }
    },
  mounted() {
    this.fetchBanners()
  },
  beforeUnmount () {
    
  },
  methods: {
    login() {
        this.allErrors = null;
        this.$store.dispatch('auth/login', this.form)
        .then(() => window.location.href = process.env.VUE_APP_BASE)
        .catch((err) => {
            this.allErrors = err.errors
            if(this.allErrors.email && this.allErrors.email[0] == 'Please verify your email to proceed.'){
                this.isShowResend = true
            }else{
                this.isShowResend = false
            }
            this.showFailMsg(err.message);
        })
        .finally(() => this.loading = false);
    },
    resendVerification() {
        this.allErrors = null;
        this.axios.post('/resend-verification-link', {
            email: this.form.email
        })
        .then(({ data }) => {
            this.showSuccessMsg(data.message);
        })
        .catch((err) => {
            this.allErrors = err.errors
            this.showFailMsg(err.message);
        })
    },
    fetchBanners() {
        this.axios.get('/get-banners')
        .then(({ data }) => {
            this.banner = data.data;
        })
    },
    openChatBox() {
      this.isOpenChat = !this.isOpenChat
    },
  }
}
</script>
<style scoped>
 .resend_link{
    cursor: pointer;
    text-decoration: none;
    color: #ffffff;
    float: right;
    margin-top: 7px;
    margin-bottom: 7px;
 }
</style>